import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { ImageModule } from '@epicuro-next/ataraxia/image';
import { ProductPriceModule } from '@epicuro-next/ataraxia/product-price';
import { ProductTitleModule } from '@epicuro-next/ataraxia/product-title';
import { VideoJsMediaPlayerModule } from '@epicuro-next/ataraxia/videojs-media-player';
import { ProductListStoreModule } from '@epicuro-next/state/product-list-state';

import { EpicShowPlayerComponent } from './components/epic-show-player/epic-show-player.component';
import { EpicShowPresentationPcardComponent } from './components/epic-show-presentation-pcard/epic-show-presentation-pcard.component';
import { EpicShowProductPresentationComponent } from './components/epic-show-product-presentation/epic-show-product-presentation.component';
import { EpicShowService } from './service/epic-show.service';

@NgModule({
  declarations: [
    EpicShowProductPresentationComponent,
    EpicShowPresentationPcardComponent,
    EpicShowPlayerComponent,
  ],
  exports: [EpicShowPlayerComponent],
  imports: [
    CommonModule,
    ProductListStoreModule,
    IconsModule,
    ImageModule,
    VideoJsMediaPlayerModule,
    ProductTitleModule,
    ProductPriceModule,
  ],
  providers: [EpicShowService],
})
export class EpicShowPlayerModule {}
